import React, { useState, useEffect } from 'react';
import BasicSelect from '../../../components/shared/fields/BasicSelect';

const PaymentFilter = ({ onChange, clearFilter }) => {
    const paymentOptions = [
        { value: false, label: 'Manual' },
        { value: true, label: 'Automática' },
    ];

    const [payment, setPayment] = useState(paymentOptions.map((opt) => opt.value));

    const handlePaymentChange = (event) => {
        const { value } = event.target;
        const updated = typeof value === 'string' ? value.split(',') : value;

        setPayment(updated);
        onChange(updated);
    };

    useEffect(() => {
        if (clearFilter) {
            setPayment(paymentOptions.map((opt) => opt.value));
        }
    }, [clearFilter]);

    return (
        <BasicSelect
            label="Pagamento"
            value={payment}
            multiple
            limitTags={2}
            onChange={handlePaymentChange}
            options={paymentOptions}
            renderValue={(selected) => {
                if (selected.length === paymentOptions.length) return 'Todos';

                const labels = paymentOptions
                    .filter(opt => selected.includes(opt.value))
                    .map(opt => opt.label);

                return labels.join(', ');
            }}
        />
    );
};

export default PaymentFilter;
